import React from 'react';
import '../src/App.css';

class App extends React.Component {
  render() {
    return (
       <>
        <h1>Amar shonar bangla</h1>
       </>
    )
  }
}

export default App;
